import script from "./ProductPackagingUnits.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPackagingUnits.vue?vue&type=script&setup=true&lang=ts"

import "./ProductPackagingUnits.vue?vue&type=style&index=0&id=d60bb4ea&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d60bb4ea"]])

export default __exports__